import { useState, useEffect, useRef } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import debounce from 'lodash.debounce';

const loader = new Loader({
  apiKey: `${process.env.REACT_APP_GOOGLE_MAPS_ID}`, // tu clave
  version: 'weekly',
});

const usePlacesAutocomplete = (inputValue, debounceDelay = 800) => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const debouncedFetchRef = useRef();

  useEffect(() => {
    let isMounted = true;

    const loadSuggestions = async (input) => {
      if (!input) {
        if (isMounted) {
          setSuggestions([]);
          setLoading(false);
        }
        return;
      }

      if (isMounted) setLoading(true);

      try {
        const { AutocompleteSuggestion, AutocompleteSessionToken } = await loader.importLibrary('places');
        const sessionToken = new AutocompleteSessionToken();
        const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
          input,
          sessionToken,
        });
        if (isMounted) setSuggestions(suggestions);
      } catch (error) {
        console.error('Error fetching places:', error);
        if (isMounted) setSuggestions([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    // Creamos nueva función debounced cada vez que cambia input
    const debouncedFetch = debounce(loadSuggestions, debounceDelay);
    debouncedFetchRef.current = debouncedFetch;

    debouncedFetch(inputValue);

    return () => {
      isMounted = false;
      debouncedFetch.cancel(); // 👈 Cancelar la ejecución debounced pendiente
    };
  }, [inputValue, debounceDelay]);

  return { suggestions, loading, clearSuggestions: () => setSuggestions([]) };

};

export default usePlacesAutocomplete;
